import React, { useEffect, useState } from "react";
const SESSION_KEY = "atletismo-resuelto-launch-end";
const INITIAL_SECONDS = 23 * 60 * 60 + 59 * 60 + 58;
function getEndTime() {
  const stored = window.sessionStorage.getItem(SESSION_KEY);
  const parsed = stored ? Number(stored) : 0;
  if (parsed > Date.now()) return parsed;
  const next = Date.now() + INITIAL_SECONDS * 1000;
  window.sessionStorage.setItem(SESSION_KEY, String(next));
  return next;
}
export function Countdown() {
  const [remaining, setRemaining] = useState(INITIAL_SECONDS);
  useEffect(() => {
    let endTime = getEndTime();
    const tick = () => {
      const seconds = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      if (seconds === 0) {
        endTime = Date.now() + INITIAL_SECONDS * 1000;
        window.sessionStorage.setItem(SESSION_KEY, String(endTime));
        setRemaining(INITIAL_SECONDS);
        return;
      }
      setRemaining(seconds);
    };
    tick();
    const interval = window.setInterval(tick, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const values = [{
    label: "Horas",
    value: Math.floor(remaining / 3600)
  }, {
    label: "Minutos",
    value: Math.floor(remaining % 3600 / 60)
  }, {
    label: "Segundos",
    value: remaining % 60
  }];
  return <div className="flex items-start justify-center gap-2 sm:gap-4" role="timer" aria-label="Tiempo restante del precio de lanzamiento" data-id="element-52" data-mp="12rwtew5skopm">
      {values.map((item, index) => <React.Fragment key={item.label} data-id="element-53" data-mp="f4ew6l3rcyf9" data-mpi={index}>
          <div className="min-w-[76px] rounded-xl border border-[#F5B83D]/25 bg-[#080B14]/80 px-3 py-3 text-center shadow-inner sm:min-w-[104px] sm:px-5 sm:py-4" data-id="element-54" data-mp="a40wbqcb8usb">
            <span className="block font-mono text-3xl font-black tabular-nums text-[#FFD66B] sm:text-5xl" data-id="element-55" data-mp="o0nv7yntpv0v">
              {String(item.value).padStart(2, "0")}
            </span>
            <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.18em] text-[#8E9AAA] sm:text-xs" data-id="element-56" data-mp="1zgci6q12uu1o">{item.label}</span>
          </div>
          {index < values.length - 1 && <span className="pt-3 font-mono text-2xl font-bold text-[#C81724] sm:pt-5 sm:text-3xl" data-id="element-57" data-mp="s4v8ljyyfii7">:</span>}
        </React.Fragment>)}
    </div>;
}